import axios from 'axios';
import one360 from './one360';
import { AuthUser } from '../../types/auth';
import { AUTH_ME_TIMEOUT_MS } from '../../constants/auth';

export async function fetchMeAsync(idToken: string, timeoutMs: number = AUTH_ME_TIMEOUT_MS): Promise<AuthUser> {
  try {
    return await one360.get<AuthUser>('/api/v1/auth/me', {
      headers: { Authorization: `Bearer ${idToken}` },
      timeout: timeoutMs,
    });
  } catch (err: any) {
    if (axios.isCancel(err)) throw err;
    console.error('[Auth] fetchMe fehlgeschlagen:', err);
    throw err;
  }
}
